export default "__VITE_ASSET__BKEQpCUF__"